'use strict';
const mmWidgets = require('./mm-widgets'),
	TAG_PREFIX = 'tag:';
mmWidgets.fn.goldFileTagNavWidget = function (goldFileListModel) {
	return mmWidgets.each(this, function () {
		const element = this,
			tagsContainer = element.find('[data-mm-role~="fileTagNavContainer"]'),
			template = element.find('[data-mm-role~="file-tag-nav-template"]').remove();
		goldFileListModel.addEventListener('context', (context) => {
			if (!context || !context.showTagFilters || context.currentAction) {
				return;
			}
			const filterType = (Array.isArray(context.filterType) && context.filterType) || [],
				selectedTags = filterType.filter(i => i.startsWith(TAG_PREFIX)).map(i => i.slice(TAG_PREFIX.length)),
				filteredTags = context.filteredTags || [],
				unselectedTags = filteredTags.filter(i => !selectedTags.includes(i)),
				appendTag = (tag, isSelected) => {
					const tagItem = template.clone();
					tagItem.text(tag);
					tagItem.click(() => {
						const newFilter = isSelected ?  selectedTags.filter(i => i !== tag) : selectedTags.concat(tag);
						goldFileListModel.setFilterForTags(newFilter);
					});
					if (isSelected) {
						tagItem.addClass('selected');
					}

					tagItem.appendTo(tagsContainer);
				};
			tagsContainer.empty();
			selectedTags.forEach(tag => appendTag(tag, true));
			unselectedTags.forEach(tag => appendTag(tag, false));
		});

	});
};
